import http from './request'

export const sliceUpload = (params) => {
    return http.post('resource/upload', params);
}
export const mergeSlice = (params) => {
    return http.post('resource/merge', params);
}
export const userLogin = (params) => {
    return http.post('login', params)
}
export const userLogout = () => {
    return http.get('logout')
}
export const adminGoodListGood = (params) => {
    return http.get('adminGood/listGood', {params: params})
}
export const add = (params) => {
    return http.post('cate/add', params)
}
export const catePage = (params) => {
    return http.get('cate/page', {params:params})
}
export const del = (id) => {
    return http.get('cate/del/' + id)
}
export const tagAdd = (params) => {
    return http.post('tag/add', params)
}
export const tag = (params) => {
    return http.post('tag', params)
}
export const tagPage = (params) => {
    return http.get('tag/page', {params:params})
}
export const tagDel = (id) => {
    return http.get('tag/del/' + id)
}
export const adminGoodRecentlyUsedCategory = () => {
    return http.get('adminGood/recentlyUsedCategory')
}
export const adminGoodGetCategory = (params) => {
    return http.get('adminGood/getCategory', {params: params})
}
export const adminGoodStepOne = (params) => {
    return http.get('adminGood/stepOne', {params: params})
}
export const adminSchoolSchools = (params) => {
    return http.get('school/schools', {params: params})
}
export const adminSchoolAdd = (params) => {
    return http.post('school/add', params)
}
export const adminSchoolInfo = (id) => {
    return http.get('school/info/' + id)
}
export const adminSchoolDel = (id) => {
    return http.get('school/del/' + id)
}
export const adminSchoolAdmins = (params) => {
    return http.get('admin/admins', {params: params})
}
export const adminSchoolAdminAdd = (params) => {
    return http.post('admin/add', params)
}
export const adminSchoolAdminInfo = (id) => {
    return http.get('admin/info/' + id)
}
export const adminSchoolAdminDel = (id) => {
    return http.get('admin/del/' + id)
}
export const adminKeyWordListKeyWord = (params) => {
    return http.get('adminKeyWord/listKeyWord', {params: params})
}
export const adminKeyWordSaveKeyWord = (params) => {
    return http.post('adminKeyWord/saveKeyWord', params)
}
export const adminKeyWordGetKeyWord = (params) => {
    return http.get('adminKeyWord/getKeyWord', {params: params})
}
export const adminKeyWordImportKeyword = (params) => {
    return http.post('adminKeyWord/importKeyword', params)
}
export const adminKeyWordGetExportKeyword = (params) => {
    return http.post('adminKeyWord/getExportKeyword', params)
}
export const adminKeyWordDelKeyWord = (params) => {
    return http.get('adminKeyWord/delKeyWord', {params: params})
}
export const theoryTopicEdit = (params) => {
    return http.post('theoryTopic/edit', params)
}
export const cate = (params) => {
    return http.get('cate', {params: params})
}
export const kefuListKefuData = (params) => {
    return http.get('kefu/listKefuData', {params: params})
}
export const kefuGetIC = () => {
    return http.get('kefu/getIC')
}
export const theoryTopicGetDetail = (params) => {
    return http.get('theoryTopic/getDetail', {params: params})
}
export const theoryTopicGetList = (params) => {
    return http.get('theoryTopic/getList', {params: params})
}
export const theoryTopicUploadRtImg = (params) => {
    return http.post('theoryTopic/uploadRtImg', params)
}
export const uploadMaterial = (params) => {
    return http.post('operationProblem/uploadMaterial',params)
}
export const paperListPaper = (params) => {
    return http.get('paper/listPaper', {params: params})
}
export const paperSavePaper = (params) => {
    return http.post('paper/savePaper', params)
}
export const paperDelPaper = (params) => {
    return http.get('paper/delPaper', {params: params})
}
export const paperGetPaper = (params) => {
    return http.get('paper/getPaper', {params: params})
}
export const adminGoodUploadImage = (params) => {
    return http.post('adminGood/uploadImage', params)
}
export const adminGoodUploadImage1 = (params) => {
    return 'adminGood/uploadImage'
}
export const adminGoodSaveGood = (params) => {
    return http.post('adminGood/saveGood', params)
}
export const adminGoodGetGood = (params) => {
    return http.get('adminGood/getGood', {params: params})
}
export const adminGoodDelGood = (params) => {
    return http.get('adminGood/delGood', {params: params})
}
export const theoryTopicExcel = (params) => {
    return http.post('theoryTopic/excel', params)
}
export const theoryTopicDel = (params) => {
    return http.post('theoryTopic/del', params)
}
export const kefuCreateSN = () => {
    return http.get('kefu/createSN')
}
export const operationProblemExamModuleList = () => {
    return http.get('operationProblem/examModuleList')
}
export const operationProblemSaveShopGoodsManagement = (params) => {
    return http.post('operationProblem/saveShopGoodsManagement', params)
}
export const operationProblemSaveCustomerService = (params) => {
    return http.post('operationProblem/saveCustomerService', params)
}
export const keFuSaveKeFuData = (params) => {
    return http.post('kefu/saveKefuData', params)
}
export const keFuGetKeFuData = (params) => {
    return http.get('kefu/getKefuData', {params: params})
}
export const keFuDelKeFuData = (params) => {
    return http.get('kefu/delKefuData', {params: params})
}
export const SaveArticlePromote = (params) => {
    return http.post('operationProblem/saveArticlePromote', params)
}
export const SaveLiveBroadcast = (params) => {
    return http.post('operationProblem/saveLiveBroadcast', params)
}
export const theoryTestPaperGetList = (params) => {
    return http.get('theoryTestPaper/getList', {params: params})
}
export const theoryTestPaperFirstPage = (params) => {
    return http.get('theoryTestPaper/firstPage', {params: params})
}
export const operationProblemSaveDataCollectGoods = (params) => {
    return http.post('operationProblem/saveDataCollectGoods', params)
}
export const operationProblemSaveDataCollect = (params) => {
    return http.post('operationProblem/saveDataCollect', params)
}
export const operationProblemDataCollectGoodsDetail = (params) => {
    return http.get('operationProblem/dataCollectGoodsDetail', {params: params})
}
export const operationProblemDataCollectDelGoods = (params) => {
    return http.get('operationProblem/dataCollectDelGoods', {params: params})
}
export const customerInfoGetModuleList = (params) => {
    return http.get('customerInfo/getModuleList', {params: params})
}
export const operationProblemGoodsSettings = (params) => {
    return http.post('operationProblem/goodsSettings', params)
}
export const operationProblemDelMaterial = (params) => {
    return http.get('operationProblem/delMaterial', {params: params})
}
export const operationProblemOpList = (params) => {
    return http.get('operationProblem/opList', {params: params})
}
export const operationProblemSaveOrderManagement = (params) => {
    return http.post('operationProblem/saveOrderManagement',params)
}
export const operationProblemGetOperation = (params) => {
    return http.get('operationProblem/getOperation',{params:params})
}
export const operationProblemOrderStatus = () => {
    return http.get('operationProblem/orderStatus',)
}
export const customerInfoEdit = (params) => {
    return http.post('customerInfo/edit',params)
}
export const customerInfoExcelInto = (params) => {
    return http.post('customerInfo/excelInto',params)
}
export const operationProblemUploadLbGoodsImg = (params) => {
    return http.post('operationProblem/uploadLbGoodsImg', params)
}
export const customerInfoGetDetail = (params) => {
    return http.get('customerInfo/getDetail', {params:params})
}
export const customerInfoDel = (params) => {
    return http.post('customerInfo/del', params)
}
export const customerInfoExcelOut = () => {
    return http.get('customerInfo/excelOut' )
}
export const customerInfoGerExcelData = (params) => {
    return http.post('customerInfo/gerExcelData', params)
}
export const theoryTestPaperEdit = (params) => {
    return http.post('theoryTestPaper/edit', params)
}
export const theoryTestPaperSecondPage = (params) => {
    return http.get('theoryTestPaper/secondPage', {params: params})
}
export const theoryTestPaperDel = (params) => {
    return http.post('theoryTestPaper/del', params)
}
export const operationProblemOpEpList = (params) => {
    return http.get('operationProblem/opEpList', {params:params})
}
export const operationProblemEpOpList = () => {
    return http.get('operationProblem/epOpList')
}
export const operationProblemSaveOpExamPapers = (params) => {
    return http.post('operationProblem/saveOpExamPapers', params)
}
export const operationProblemOpEpDetail = (params) => {
    return http.get('operationProblem/opEpDetail', {params:params})
}
export const operationProblemOpEpDel = (params) => {
    return http.get('operationProblem/opEpDel', {params:params})
}
export const probabilityGetList = (params) => {
    return http.get('probability/getList', {params: params})
}
export const probabilityGetDetail = (params) => {
    return http.get('probability/getDetail', {params: params})
}
export const probabilityOpen = (params) => {
    return http.get('probability/open', {params: params})
}
export const probabilityClose = (params) => {
    return http.get('probability/close', {params: params})
}
export const probabilityEdit = (params) => {
    return http.post('probability/edit', params)
}
export const probabilityDel = (params) => {
    return http.post('probability/del', params)
}
export const getTeacherList = (params) => {
    return http.get('teacher', {params: params})
}
export const teacherAdd = (params) => {
    return http.post('teacher/add', params)
}
export const teacherInfo = (id) => {
    return http.get('teacher/info/' + id)
}
export const teacherDel = (id) => {
    return http.get('teacher/del/' + id)
}
export const examGetTheoryByLevel = (params) => {
    return http.get('exam/getTheoryByLevel', {params: params})
}
export const examRandPaper = (params) => {
    return http.get('exam/randPaper', {params: params})
}
export const examSave = (params) => {
    return http.post('exam/save', params)
}
export const examList = (params) => {
    return http.get('exam/list', {params: params})
}
export const examStu = (params) => {
    return http.get('exam/stu', {params: params})
}
export const examEnd = (params) => {
    return http.get('exam/end', {params: params})
}
export const examDel = (params) => {
    return http.get('exam/del', {params: params})
}
export const examEditTime = (params) => {
    return http.post('exam/edit', params)
}
export const examClass = () => {
    return http.get('exam/class')
}
export const getExam = (params) => {
    return http.get('exam', {params: params})
}
export const getJudgeList = (params) => {
    return http.get('judge', {params: params})
}
export const judgeAdd = (params) => {
    return http.post('judge/add', params)
}
export const judgeInfo = (id) => {
    return http.get('judge/info/' + id)
}
export const judgeDel = (id) => {
    return http.get('judge/del/' + id)
}
export const getClassesList = (params) => {
    return http.get('classes', {params: params})
}
export const classesAdd = (params) => {
    return http.post('classes/add', params)
}
export const classesInfo = (id) => {
    return http.get('classes/info/' + id)
}
export const classesDel = (id) => {
    return http.get('classes/del/' + id)
}
export const studentAdd = (params) => {
    return http.post('student/add', params)
}
export const getStudentList = (params) => {
    return http.get('student', {params: params})
}
export const studentInfo = (id) => {
    return http.get('student/info/' + id)
}
export const studentDel = (id) => {
    return http.get('student/del/' + id)
}
export const cateCates = (params) => {
    return http.get('cate/cates',{params: params})
}
export const course = (params) => {
    return http.get('course',{params: params})
}
export const courseList = (params) => {
    return http.get('course/list',{params: params})
}
export const courseDel = (params) => {
    return http.get('course/del',{params: params})
}
export const getSchoolCourse = (params) => {
    return http.get('course/getSchoolCourse',{params: params})
}
export const getTeaSchoolCourse = (params) => {
    return http.get('course/teaSchoolCourse',{params: params})
}
export const courseSave = (params) => {
    return http.post('course/save', params)
}
export const courseUploadImage = (params) => {
    return http.post('course/uploadImage', params)
}
export const trainTheoryListTeacher = (params) => {
    return http.get('train/theoryListTeacher', {params: params})
}
export const trainTheoryListStudent = (params) => {
    return http.get('train/theoryListStudent', {params: params})
}
export const trainTheoryDetailsTeacher = (params) => {
    return http.get('train/theoryDetailsTeacher', {params: params})
}
export const stuOpGetExamInfo = (params) => {
    return http.get('stuOp/getExamInfo', {params:params})
}
export const examStuExamPage = () => {
    return http.get('exam/stuExamPage')
}
export const stuOpOpTrainList = (params) => {
    return http.get('stuOp/opTrainList',{params: params})
}
export const stuOpStuOpFreightTemplate = (params) => {
    return http.get('stuOp/stuOpFreightTemplate',{params: params})
}
export const stuOpSaveGoods = (params) => {
    return http.post('stuOp/saveGoods',params)
}
export const operationProblemUploadGoodsImg = (params) => {
    return http.post('operationProblem/uploadGoodsImg',params)
}
export const examStuExamKeyword = (params) => {
    return http.get('exam/stuExamKeyword',{params:params})
}
export const stuOpStuOpGoodsDetail = (params) => {
    return http.get('stuOp/stuOpGoodsDetail',{params:params})
}
export const stuOpStuOpGoodsList = (params) => {
    return http.get('stuOp/stuOpGoodsList',{params:params})
}
export const termsList = () => {
    return http.get('terms/list')
}
export const groupList = (params) => {
    return http.get('group/list', {params: params})
}
export const termsSearch = (params) => {
    return http.get('terms/search', {params: params})
}
export const termsImport = (params) => {
    return http.post('terms/import', params)
}
export const groupSave = (params) => {
    return http.post('group/save', params)
}
export const groupDel = (params) => {
    return http.get('group/del', {params: params})
}
export const termsDel = (params) => {
    return http.get('terms/del', {params: params})
}
export const groupOperate = (params) => {
    return http.get('group/operate', {params: params})
}
export const termsOperate = (params) => {
    return http.get('terms/operate', {params: params})
}
export const termsSave = (params) => {
    return http.post('terms/save', params)
}
export const termsUpload = (params) => {
    return 'terms/upload'
}
export const assignTopics = (params) => {
    return http.get('assign/topics',{params:params})
}
export const assignTopic = (params) => {
    return http.post('assign/topic', params)
}
export const assignExampapers = () => {
    return http.get('assign/exampapers')
}
export const assignPapers = (params) => {
    return http.get('assign/papers',{params:params})
}
export const assignPaper = (params) => {
    return http.post('assign/paper', params)
}
export const trainResetAnswerTheoryPaper = (params) => {
    return http.get('train/resetAnswerTheoryPaper', {params: params})
}
export const assignList = () => {
    return http.get('assign/list')
}
export const assignCourses = (params) => {
    return http.get('assign/courses',{params:params})
}
export const assignCourse = (params) => {
    return http.post('assign/course', params)
}
export const getKefuInfo = () => {
    return http.get('kefu')
}
export const stuOpSaveFreightTemplate = (params) => {
    return http.post('stuOp/saveFreightTemplate', params)
}
export const stuOpStuFreightTemplateDel = (params) => {
    return http.get('stuOp/stuFreightTemplateDel', {params:params})
}

export const templateStudentXlsx = () => {
    return http.get('template/student.xlsx')
}
export const studentImport = (params) => {
    return http.post('student/import', params)
}
export const resourceType = () => {
    return http.get('resource/type')
}
export const resource = (params) => {
    return http.get('resource', {params:params})
}
export const resourceAdd = (params) => {
    return http.post('resource/add', params)
}
export const getDataByCourseID = (params) => {
    return http.get('course/getDataByCourseID', {params: params})
}
export const stuOpStuOpGoodsAttribute = (params) => {
    return http.get('stuOp/stuOpGoodsAttribute', {params:params})
}
export const operationProblemStoreSettings = (params) => {
    return http.post('operationProblem/storeSettings', params)
}
export const stuOpStuOptimizeTitle = (params) => {
    return http.post('stuOp/stuOptimizeTitle', params)
}
export const stuOpStuOpGoodsDel = (params) => {
    return http.get('stuOp/stuOpGoodsDel', {params: params})
}

export const deleteResource = (id) => {
    return http.get('resource/del/'+id);
}
export const resourceInfo = (id) => {
    return http.get('resource/info/' + id);
}
export const kefuGood = (params) => {
    return http.get('kefu/good', {params: params})
}
export const examTeaOperationList = (params) => {
    return http.get('exam/teaOperationList',{params: params})
}
export const examTeaOperationDetail = (params) => {
    return http.get('exam/teaOperationDetail',{params: params})
}
export const stuOpStuOpHotGoodsList = (params) => {
    return http.get('stuOp/stuOpHotGoodsList', {params: params})
}
export const kefuSubmit = (params) => {
    return http.post('kefu/submit', params)
}
export const theoryexamStartTheoryExam = () => {
    return http.get('theoryexam/startTheoryExam')
}
export const stuOpStuOpHotGoodsDetail = (params) => {
    return http.get('stuOp/stuOpHotGoodsDetail', {params: params})
}
export const kefuStatus = (params) => {
    return http.get('kefu/status', {params: params})
}
export const kefuHistorical = () => {
    return http.get('kefu/historical')
}
export const kefuSubmitEven = (params) => {
    return http.post('kefu/submitEven', params)
}
export const theoryexamSubmitTheoryExam = (params) => {
    return http.post('theoryexam/submitTheoryExam', params)
}
export const trainStartAnswerTheoryPaper = (params) => {
    return http.get('train/startAnswerTheoryPaper', {params: params})
}
export const trainSubmitAnswerTheoryPaper = (params) => {
    return http.post('train/submitAnswerTheoryPaper', params)
}
export const trainExitAnswerTheoryPaper = (params) => {
    return http.post('train/exitAnswerTheoryPaper', params)
}
export const stuOpOrderList = (params) => {
    return http.get('stuOp/stuOpOrderList', {params:params})
}
export const stuOpOrderOperation = (params) => {
    return http.get('stuOp/stuOpOrderOperation', {params:params})
}
export const stuOpModifyOrder = (params) => {
    return http.post('stuOp/stuOpModifyOrder', params)
}
export const kefuDrill = (params) => {
    return http.get('kefu_drill', {params: params})
}
export const markGetMarkListJudge = (params) => {
    return http.get('mark/getMarkListJudge', {params:params})
}
export const markGetNoMarkListJudge = (params) => {
    return http.get('mark/getNoMarkListJudge', {params:params})
}
export const markGetNoSubmitListJudge = (params) => {
    return http.get('mark/getNoSubmitListJudge', {params:params})
}
export const markStartMarkJudge = (params) => {
    return http.get('mark/startMarkJudge', {params:params})
}
export const courseApplyTemplate = (params) => {
    return http.post('course/applyTemplate', params)
}
export const courseSaveTemplate = (params) => {
    return http.post('course/saveTemplate', params)
}
export const courseTemplateList = (params) => {
    return http.get('course/templateList', {params: params})
}
export const courseGetTemplateData = (params) => {
    return http.get('course/getTemplateData', {params: params})
}
export const courseDelTemplate = (params) => {
    return http.get('course/delTemplate', {params: params})
}
export const kefu_drillStatus = (params) => {
    return http.get('kefu_drill/status', {params: params})
}
export const kefu_drillSubmit = (params) => {
    return http.post('kefu_drill/submit', params)
}
export const kefu_drillHistorical = (params) => {
    return http.get('kefu_drill/historical', {params: params})
}
export const kefu_drillSubmitEven = (params) => {
    return http.post('kefu_drill/submitEven', params)
}
export const kefu_drillGood = (params) => {
    return http.get('kefu_drill/good', {params: params})
}
export const kefu_drillTrainingRecord = (params) => {
    return http.get('kefu_drill/trainingRecord', {params: params})
}
export const markSubmitMarkJudge = (params) => {
    return http.post('mark/submitMarkJudge', params)
}
export const markGenerateReport = (params) => {
    return http.get('mark/generateReport', {params: params})
}
export const markGetMarkListTeacher = (params) => {
    return http.get('mark/getMarkListTeacher', {params: params})
}
export const markGetNoMarkListTeacher = (params) => {
    return http.get('mark/getNoMarkListTeacher', {params: params})
}
export const markGetNoSubmitListTeacher = (params) => {
    return http.get('mark/getNoSubmitListTeacher', {params: params})
}
export const markStartMarkTeacher = (params) => {
    return http.get('mark/startMarkTeacher', {params: params})
}
export const markSubmitMarkTeacher = (params) => {
    return http.post('mark/submitMarkTeacher', params)
}
export const personalAdd = (params) => {
    return http.post('personal/add', params)
}
export const personalList = (params) => {
    return http.get('personal', {params: params})
}
export const personalDel = (id) => {
    return http.get('personal/del/'+ id)
}
export const examGradingManagementList = (params) => {
    return http.get('exam/gradingManagementList', {params: params})
}
export const certificateCertificateTemplate = (params) => {
    return http.post('certificate/certificate_template', params)
}
export const certificateTemplateList = (params) => {
    return http.get('certificate/certificateTemplateList', {params:params})
}
export const delCertificateTemplate = (params) => {
    return http.post('certificate/del_certificate_template', params)
}
export const certificateGetExamList = (params) => {
    return http.get('certificate/getExamList', {params:params})
}
export const getStudentCertificateList = (params) => {
    return http.post('certificate/getStudentCertificateList', params)
}
export const getNOStudentCertificateList = (params) => {
    return http.post('certificate/getNOStudentCertificateList', params);
}
export const certificateWhetherTemplate = (params) => {
    return http.get('certificate/whetherTemplate', {params: params});
}
export const certificateInfo = (params) => {
    return http.post('certificate/certificate_info', params)
}
export const delCertificate = (params) => {
    return http.post('certificate/del_certificate', params)
}
export const certificateTemplate = (params) => {
    return http.get('certificate/template', {params: params})
}
export const studentCertificate = (params) => {
    return http.get('certificate/studentCertificate', {params: params})
}
export const certificateEditTemplate = (params) => {
    return http.post('certificate/certificate_edit_template', params)
}
export const certificateShowTemplate = (params) => {
    return http.get('certificate/certificate_show_template', {params: params})
}
export const examExamList = (params) => {
    return http.get('exam/examList', {params: params})
}

export const calcExam = (params) => {
    return http.get("exam/calculation", {params: params})
}
export const examExamStuList = (params) => {
    return http.get('exam/examStuList', {params: params})
}
export const examExportStuScore = (params) => {
    return http.get('exam/exportStuScore', {params: params})
}
export const theoryexamAnswerDetail = (params) => {
    return http.get('theoryexam/answerDetail', {params: params})
}
export const schoolReportManagementList = (params) => {
    return http.get('exam/schoolReportManagementList', {params: params})
}
export const reportManagementStuList = (params) => {
    return http.get('exam/reportManagementStuList', {params: params})
}
export const operationProblemOpDetail = (params) => {
    return http.get('operationProblem/opDetail', {params: params})
}
export const operationProblemOpDel = (params) => {
    return http.get('operationProblem/opDel', {params: params})
}
export const paperGetKefuTopic = (params) => {
    return http.get('paper/getKefuTopic', {params: params})
}
export const reportManagementList = (params) => {
    return http.get('exam/reportManagementList', {params: params})
}
export const theoryTestPaperGetNameByCategory = (params) => {
    return http.get('theoryTestPaper/getNameByCategory', {params: params})
}
export const examGetPaperByCategory = (params) => {
    return http.get('exam/getPaperByCategory', {params: params})
}
export const examGetTheoryByCategory = (params) => {
    return http.get('exam/getTheoryByCategory', {params: params})
}
export const trainAnswerDetailListTeacher = (params) => {
    return http.get('train/answerDetailListTeacher', {params: params});
}
export const trainAnswerDetailTeacher = (params) => {
    return http.get('train/answerDetailTeacher', {params: params});
}
export const examSeeStuReport = (params) => {
    return http.get('exam/seeStuReport', {params: params})
}
export const theoryexamMarkDetail = (params) => {
    return http.get('theoryexam/markDetail', {params: params})
}
export const examStuOperationDetail = (params) => {
    return http.get('exam/stuOperationDetail', {params: params})
}
export const examGetExamRate = (params) => {
    return http.get('exam/getExamRate', {params: params})
}
export const examStuKefuExamDetail = (params) => {
    return http.get('exam/stuKefuExamDetail', {params: params})
}
export const getClassName = (params) => {
    return http.get('certificate/getClassName', {params: params})
}
export const trainAnswerDetailListStudent = (params) => {
    return http.get('train/answerDetailListStudent', {params: params})
}
export const trainAnswerDetailStudent = (params) => {
    return http.get('train/answerDetailStudent', {params: params})
}
export const kefu_drillStuResetDrill = (params) => {
    return http.get('kefu_drill/stuResetDrill', {params: params})
}
export const examStuDrillKefuDetail = (params) => {
    return http.get('exam/stuDrillKefuDetail', {params: params})
}
export const operationProblemCustomerServiceList = (params) => {
    return http.get('operationProblem/customerServiceList', {params: params})
}
export const infocenterteacherIndexdata = (params) => {
    return http.get('infocenterteacher/indexdata', {params: params})
}
export const infocenterteacherCenterClassList = (params) => {
    return http.get('infocenterteacher/centerClassList', {params: params})
}
export const infocenterschoolIndexdata = (params) => {
    return http.get('infocenterschool/indexdata', {params: params})
}
export const infocenterschoolCenterClassList = (params) => {
    return http.get('infocenterschool/centerClassList', {params: params})
}
export const createERCode = (params) => {
    return http.get('certificate/createERCode', {params: params})
}
export const termsGet = (params) => {
    return http.get('terms/get', {params: params})
}
export const batchCreateCertificate = (params) => {
    return http.post('certificate/batchCreateCertificate', params)
}
export const nextCertificate = (params) => {
    return http.get('certificate/nextCertificate', {params: params});
}
export const batchPrintCertificate = (params) => {
    return http.get('certificate/batchPrintCertificate', {params: params});
}

export const categoryLists = (params) => {
    return http.get('assign/getSchoolCategory', {params: params});
}



